import { apiSlice } from '../apiSlice';
import { SuccessResponse, Paginated } from '../DTO/common.interface';
import {
	CreateSubFaq,
	InformationqaQuestion,
	InformationQaQuestionDTO,
	SortSubFaqListDTO,
	SubFaqPageFilter,
} from '../DTO/information/subFaq.interface';

export const subFaqApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getSubFaqList: builder.query<
			SuccessResponse<Paginated<InformationQaQuestionDTO>>,
			SubFaqPageFilter
		>({
			query: (body) => ({
				url: `/web/information/qa-question/page`,
				method: 'POST',
				body,
			}),
			providesTags: ['SubFaqList'],
		}),
		sortSubFaqList: builder.mutation<
			SuccessResponse<any>,
			{ sortList: SortSubFaqListDTO[] }
		>({
			query: (body) => ({
				url: `/web/information/qa-question/sort`,
				method: 'POST',
				body,
			}),
			invalidatesTags: ['SubFaqList'],
		}),
		createSubFaq: builder.mutation<SuccessResponse<any>, CreateSubFaq>({
			query: (body) => ({
				url: `/web/information/qa-question`,
				method: 'POST',
				body,
			}),
		}),
		subFaqDetail: builder.query<SuccessResponse<InformationqaQuestion>, string>(
			{
				query: (id) => ({
					url: `/web/information/qa-question/${id}`,
					method: 'GET',
				}),
				providesTags: ['SubFaqDetail'],
			}
		),
		deleteSubFaq: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/information/qa-question/${id}`,
				method: 'DELETE',
			}),
		}),
		updateSubFaq: builder.mutation<SuccessResponse<any>, InformationqaQuestion>(
			{
				query: (body) => ({
					url: `/web/information/qa-question`,
					method: 'PUT',
					body,
				}),
				invalidatesTags: ['SubFaqDetail'],
			}
		),
	}),
});

export const {
	useGetSubFaqListQuery,
	useSortSubFaqListMutation,
	useCreateSubFaqMutation,
	useSubFaqDetailQuery,
	useDeleteSubFaqMutation,
	useUpdateSubFaqMutation,
} = subFaqApiSlice;
